var map = {
	"./truck-icon-idle.svg": 249,
	"./truck-icon-keyon.svg": 621,
	"./truck-icon-offline.svg": 250,
	"./truck-icon-running.svg": 197,
	"./truck-icon-stopped.svg": 352
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 623;